import { render, staticRenderFns } from "./ActivityTopicView.vue?vue&type=template&id=6ad3de38"
import script from "./ActivityTopicView.vue?vue&type=script&lang=js"
export * from "./ActivityTopicView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports